import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

import ButtonLink from "../ButtonLink"

const YesPhotoCard = ({ fluid, title, text, date, handle }) => {
  return (
    <li className="blogCard bg-white grid gap-x-5 gap-y-5 p-5 grid-cols-blogCardSm lg:grid-flow-col lg:grid-cols-blogCard  justify-start rounded">
      <div className="w-full">
        <Img
          className="object-cover"
          fluid={{ ...fluid, aspectRatio: 6 / 4 }}
          className=" justify-self-start"
          style={{ borderRadius: "0.25rem" }}
        />
      </div>

      {/* text and info container */}
      <div className=" grid grid-rows-containerContent ">
        {/* This parent div is here because of gridRowsContent row settings.  Maybe change to be more flexibile? */}
        <div>
          <h3 className="mb-2 text-4xl">{title}</h3>
          {date ? (
            <div className="mb-3 italic text-blue-med text-base ">
              Published: {date}
            </div>
          ) : null}
        </div>

        <p className=" mb-4" style={{ minWidth: "300px" }}>
          {text}
        </p>

        {/* <ButtonLink
    url={`/news/${handle}`}
    text="Read More"
    classNames=" self-end justify-self-end"
  /> */}
        <div className="flex justify-end">
          <ButtonLink
            handle={`news/${handle}`}
            className="text-center text-2xl"
            text="Read More"
          />
        </div>
      </div>
    </li>
  )
}

const NoPhotoCard = ({ title, text, date, handle }) => {
  return (
    <li className="blogCard bg-white flex flex-col lg:flex-row gap-x-5 gap-y-5 p-5 justify-start rounded">
      {/* text and info container */}
      <div className="w-full grid grid-rows-containerContent ">
        {/* This parent div is here because of gridRowsContent row settings.  Maybe change to be more flexibile? */}
        <div className="mx-20">
          <h3 className=" text-center lg:text-left mb-2 text-4xl">{title}</h3>
          {date ? (
            <div className="mb-3 italic text-blue-med text-base ">
              Published: {date}
            </div>
          ) : null}
        </div>

        <p className=" mb-4" style={{ minWidth: "300px" }}>
          {text}
        </p>

        {/* <ButtonLink
url={`/news/${handle}`}
text="Read More"
classNames=" self-end justify-self-end"
/> */}
        <div className="flex justify-end">
          <ButtonLink
            handle={`news/${handle}`}
            className="text-center text-2xl"
            text="Read More"
          />
        </div>
      </div>
    </li>
  )
}

export default ({
  fluid = null,
  text = "Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web de- signs. The passage is attributed to an unknown.....",
  title = "Post Title",
  handle = "#",
  date = null,
  className = "",
}) => {
  const data = useStaticQuery(graphql`
    query BlogCardQuery {
      defaultBlogImageQuery: allFile(
        filter: { name: { eq: "defaultBlogImage" } }
      ) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  const defaultBlogImage =
    data.defaultBlogImageQuery.edges[0].node.childImageSharp.fluid

  // if fluid is null (i.e. not passed in as a prop), use default image
  fluid = fluid ? fluid : null

  return (
    <div className={`${className}`}>
      {fluid ? (
        <YesPhotoCard
          fluid={fluid}
          title={title}
          text={text}
          date={date}
          handle={handle}
        />
      ) : (
        <NoPhotoCard title={title} text={text} date={date} handle={handle} />
      )}
    </div>
  )
}
